import {ValidatedTextInputField} from 'common';
import {FormField, Text, TextProps} from 'evergreen-ui';
import React, {memo} from 'react';
import {useFormContext, useWatch} from 'react-hook-form';

import { userInputValidationRules } from '../../../domain/validationRules';
import {UserFormInput, UserFormInputCommonProps} from '../types';


const COMMON_PROPS = {
    name: 'email' as keyof UserFormInput,
    label: <span className='text-base font-normal'>Email</span>,
    placeholder: 'john.doe@example.com',
    validationRules: {
        required: userInputValidationRules.required,
        pattern: userInputValidationRules.emailPattern,
    },
};

export const EditableEmailInput = (passthroughsProps: UserFormInputCommonProps) => {
    return (<ValidatedTextInputField<UserFormInput>
        {...passthroughsProps}
        {...COMMON_PROPS}
        type="email"
    />);
};

type ReadOnlyEmailInputProp = Omit<TextProps, 'defaultValue'>;
export const ReadOnlyEmailInput = memo((props: ReadOnlyEmailInputProp) => {
    const {register, control} = useFormContext<UserFormInput>();
    const email = useWatch<UserFormInput, 'email'>({
        control,
        name: 'email',
    });
    return (
        <FormField label={COMMON_PROPS.label}>
            <input
                {...register(COMMON_PROPS.name, COMMON_PROPS.validationRules)}
                type='hidden' />
            <Text {...props}>{email}</Text>
        </FormField>
    );
});


